import { gsap } from 'gsap';

class PointerFollow {
  constructor(el) {
    this.dom = {el: el}
    this.dom.body = document.querySelector('body');
    this.dom.pointer = this.dom.el.querySelector('[data-js="drag-pointer"]');
    this.dom.hover = this.dom.el.querySelector('[data-js="pointer-hover"]');

    this.gsap = null;
    this.pos = { x: 0, y: 0 }; // マウスカーソルの座標
    this.mouse = { x: this.pos.x, y: this.pos.y }; // 0.01〜1 数値が大きほど早い
    this.speed = 0.1;

    this.mouseMoveEvent = this.mouseMoveEvent.bind(this);

    if (!this.dom.pointer) {
      this.follower = document.createElement('div');
      this.follower.dataset.js = 'pointer';
      this.follower.classList.add('c-pointer-follow');
  
      this.followerInner = document.createElement('div');
      this.followerInner.classList.add('c-pointer-follow__inner');
      
      this.followerText = document.createElement('span');
  
      this.followerInner.appendChild(this.followerText);
      this.follower.appendChild(this.followerInner);
      this.dom.body.appendChild(this.follower);
    } else {
      this.follower = this.dom.pointer;
    }
    this.init();
  }

  init() {
    const _this = this;

    const options = {
      xPercent: 0,
      yPercent: -50,
    }
    this.gsap = gsap.set(this.follower, options);

    // 遅延するカーソルの座標を設定する
    let followerSetX = gsap.quickSetter(this.follower, 'x', 'px');
    let followerSetY = gsap.quickSetter(this.follower, 'y', 'px');

    // マウスカーソル座標を取得する
    this.dom.hover.addEventListener('mousemove', this.mouseMoveEvent);

    gsap.ticker.add(()=>{
      const dt = 1.0 - Math.pow(1.0 - _this.speed, gsap.ticker.deltaRatio());
      // console.log({followerSetX})
      console.log(_this.mouse.x)
      console.log(_this.pos.x)
      _this.pos.x += (_this.mouse.x - _this.pos.x) * dt;
      _this.pos.y += (_this.mouse.y - _this.pos.y) * dt;
      followerSetX(_this.pos.x);
      followerSetY(_this.pos.y);
    });

    this.hoverEvent();
  }
  
  hoverEvent() {
    const _this = this;
    // マウスイベント
    // [...this.dom.hover].forEach(el=>{
      this.dom.hover.addEventListener('mouseenter', function() {
        _this.enterTrigger();
      });
  
      this.dom.hover.addEventListener('mouseleave', function() {
        _this.leaveTrigger();
      });
    // })
  }

  enterTrigger() {
    this.follower.dataset.is = 'show';
  }
  
  leaveTrigger() {
    this.follower.removeAttribute('data-is');
  }

  mouseMoveEvent(e) {
    const target_rect = this.dom.hover.getBoundingClientRect();
    // const x = e.clientX - target_rect.left;
    // const y = e.clientY - target_rect.top;
    this.mouse.x = e.clientX - target_rect.left;
    this.mouse.y = e.clientY - target_rect.top;
    console.log(this.mouse.x)
    console.log(this.mouse.y)
  }

  destroy() {
    const _this = this;
    console.log('destroy',this.gsap)
    // this.gsap.kill();
    document.removeEventListener('mousemove', this.mouseMoveEvent);
    // this.gsap = null;
    this.follower.removeAttribute('style');
  }
}

export default PointerFollow